import type { User } from '../types';

export const GENDER_ZH: Record<User['gender'], string> = {
  unspecified: '未知',
  male: '男',
  female: '女',
};
